import { createContext, useContext } from 'react'

import type { UserPkg } from '@/api/user-package/types/UserPkg'

export type OnboardingTourContextValue = {
  isActive: boolean
  stepIndex: number
  /** Demo packages injected while the tour is on the packages steps. */
  demoPkgs: UserPkg[] | null
  /** Force the first package card's actions menu open (step 3). */
  forcePkgActionsOpen: boolean
}

const OnboardingTourContext = createContext<OnboardingTourContextValue>({
  isActive: false,
  stepIndex: 0,
  demoPkgs: null,
  forcePkgActionsOpen: false,
})

export const OnboardingTourProvider = OnboardingTourContext.Provider

export const useOnboardingTour = () => useContext(OnboardingTourContext)
